import { Card, Form, Input, InputNumber, Select } from 'antd';
import React from 'react';
import * as _ from 'lodash';
import { CollectDestPreviewState, NetworkSetting, TokenSetting } from '../../usdt-providers/collectSettingProvider';
import TransferModeSettingFrom from './TransferModeSettingFrom';

const CollectTokenSettingForm = (props: {
  channel: string;
  data: any;
  tokenSetting: TokenSetting;
  networkFeeSetting: NetworkSetting;
  preview: CollectDestPreviewState;
}) => {
  const preview = props.preview;
  // 四態(loading / failed / 非純代收 / 商戶錢包數不是 1 / 正常)一次算好,
  // 下面 JSX 只消費結果,不重複判斷。preview !== 'loading' && !== 'failed' 時
  // TS 會把它narrow 成 CollectDestPreview。
  let selectDisabled: boolean;
  let mchOptionDisabled: boolean;
  let destTypeExtra: string | undefined;
  if (preview === 'loading') {
    selectDisabled = true;
    mchOptionDisabled = true;
    destTypeExtra = '載入中…';
  } else if (preview === 'failed') {
    selectDisabled = true;
    mchOptionDisabled = true;
    destTypeExtra = '載入失敗,請重新整理再確認';
  } else if (!preview.collectOnly) {
    selectDisabled = true;
    mchOptionDisabled = preview.mchWalletCount !== 1;
    destTypeExtra = '只有「純代收商戶」可以改;要改請先到商戶清單開啟純代收';
  } else if (preview.mchWalletCount !== 1) {
    selectDisabled = false;
    mchOptionDisabled = true;
    destTypeExtra = `這個商戶目前有 ${preview.mchWalletCount ?? 0} 顆可用商戶錢包,必須剛好 1 顆才能選「商戶錢包」`;
  } else {
    selectDisabled = false;
    mchOptionDisabled = false;
    destTypeExtra = undefined;
  }

  return (
    <>
      {
        _.map(props.data, (tokenObj, token) => {
          if (tokenObj.active) {
            return (

              <Card key={props.channel + '_' + token} title={token + '設定'} style={{ marginBottom: 16 }}>
                {props.channel === 'TRON' && token === 'USDT' ? (
                  <Form.Item
                    key={props.channel + '_' + token + '_collectDestType'}
                    name={props.channel + '_' + token + '_collectDestType'}
                    label='歸集目的地'
                    extra={destTypeExtra}
                  >
                    <Select disabled={selectDisabled}>
                      <Select.Option value='PAYOUT'>系統出款錢包</Select.Option>
                      <Select.Option
                        value='MCH'
                        disabled={mchOptionDisabled}
                      >
                        商戶錢包
                      </Select.Option>
                    </Select>
                  </Form.Item>
                ) : null}
                <Form.Item
                  key={props.channel + '_' + token + '_collectDest'}
                  name={props.channel + '_' + token + '_collectDest'}
                  label='實際歸集地址'
                  extra='唯讀。由上面的目的地即時解析,不是設定值。'
                >
                  <Input disabled={true} />
                </Form.Item>
                <Form.Item
                  key={props.channel + '_' + token + '_minimumAmount'}
                  name={props.channel + '_' + token + '_minimumAmount'}
                  label='最小歸集金額'
                  rules={[{ required: true, message: '請輸入 `最小歸集金額`' }]}
                >
                  <InputNumber precision={6} min={0} step={1} />
                </Form.Item>
                <TransferModeSettingFrom
                  transferMode={props.networkFeeSetting[props.channel][token].transferMode}
                  staticFee ={props.networkFeeSetting[props.channel][token].staticFee}
                  channel={props.channel}
                  token={token}/>
              </Card>);
          }
        })
      }
    </>
  );
};

export default CollectTokenSettingForm;

